/*!
VueLayers
Web map Vue components with the power of OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.10.25
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _Object$freeze = _interopDefault(require('babel-runtime/core-js/object/freeze'));
var Observable = require('rxjs/Observable');
var merge = require('rxjs/observable/merge');
var debounceTime = require('rxjs/operator/debounceTime');
var _do = require('rxjs/operator/do');
var collection = require('../ol-ext/collection');
var observableFromOlEvent = _interopDefault(require('../rx-ext/from-ol-event'));
var assert = require('../util/assert');
var mergeDescriptors = _interopDefault(require('../util/multi-merge-descriptors'));
var featuresContainer = _interopDefault(require('./features-container'));
var projTransforms = _interopDefault(require('./proj-transforms'));
var source = _interopDefault(require('./source'));

var props = {
  useSpatialIndex: {
    type: Boolean,
    default: true
  }
};

var computed = {
  featuresViewProj: function featuresViewProj() {
    if (this.rev && this.resolvedDataProjection && this.$source) {
      return this.getFeatures().map(this.writeFeatureInViewProj.bind(this));
    }
    return [];
  }
};

var methods = {
  /**
   * @return {void}
   */
  clear: function clear() {
    featuresContainer.methods.clearFeatures.call(this);
  },

  /**
   * @return {SourceCollectionAdapter}
   * @protected
   */
  getFeaturesTarget: function getFeaturesTarget() {
    if (this._featuresTarget == null && this.$source) {
      this._featuresTarget = new collection.SourceCollectionAdapter(this.$source);
    }

    return this._featuresTarget;
  },

  /**
   * @return {Object}
   * @protected
   */
  getServices: function getServices() {
    return mergeDescriptors(source.methods.getServices.call(this), featuresContainer.methods.getServices.call(this));
  },

  /**
   * @return {Promise}
   * @protected
   */
  init: function init() {
    return source.methods.init.call(this);
  },

  /**
   * @return {void|Promise<void>}
   * @protected
   */
  deinit: function deinit() {
    return source.methods.deinit.call(this);
  },

  /**
   * @return {void}
   * @protected
   */
  mount: function mount() {
    source.methods.mount.call(this);
  },

  /**
   * @return {void}
   * @protected
   */
  unmount: function unmount() {
    this.clear();
    source.methods.unmount.call(this);
  },

  /**
   * @return {void}
   * @protected
   */
  subscribeAll: function subscribeAll() {
    subscribeToSourceChanges.call(this);
  },

  /**
   * @param feature
   * @return {ReadonlyArray<any>}
   * @protected
   */
  writeFeatureInDataProj: function writeFeatureInDataProj(feature) {
    return _Object$freeze(projTransforms.methods.writeFeatureInDataProj.call(this, feature));
  },

  /**
   * @param feature
   * @return {ReadonlyArray<any>}
   * @protected
   */
  writeGeometryInViewProj: function writeGeometryInViewProj(feature) {
    return _Object$freeze(projTransforms.methods.writeFeatureInViewProj.call(this, feature));
  }
};

var vectorSource = {
  mixins: [source, featuresContainer, projTransforms],
  props: props,
  computed: computed,
  methods: methods,
  stubVNode: {
    empty: false,
    attrs: function attrs() {
      return {
        class: this.$options.name
      };
    }
  }
};

function subscribeToSourceChanges() {
  var _context,
      _this = this;

  assert.hasSource(this);

  var add = (_context = observableFromOlEvent(this.$source, 'addfeature'), _do._do).call(_context, function (_ref) {
    var feature = _ref.feature;

    _this.addFeature(feature);
  });
  var remove = (_context = observableFromOlEvent(this.$source, 'removefeature'), _do._do).call(_context, function (_ref2) {
    var feature = _ref2.feature;

    _this.removeFeature(feature);
  });
  var changeFeature = observableFromOlEvent(this.$source, 'changefeature');

  var events = merge.merge.call(Observable.Observable, add, remove, changeFeature);

  this.subscribeTo(events, function (evt) {
    ++_this.rev;
    _this.$emit(evt.type, evt);
  });
  // emit event to allow `sync` modifier
  this.subscribeTo(debounceTime.debounceTime.call(events, 100), function () {
    _this.$emit('update:features', _this.getFeatures().map(_this.writeFeatureInDataProj.bind(_this)));
  });
}

module.exports = vectorSource;



//////////////////
// WEBPACK FOOTER
// ./~/vuelayers/lib/mixin/vector-source.js
// module id = 239
// module chunks = 1